photosContainer = document.getElementById("photos-container")
moreBtn = document.getElementById("more-btn")

btnLoadingMessage = "Chargement en cours ..."
btnStandardMessage = moreBtn.textContent

nextPageToLoad = 2
restUrl = "/rest/nouveautes/page/"
maxNbPage = 7

imgHeight = 200
imgClass = "chatons-dg-photo"

moreBtn.onclick = ->
	xhr = new XMLHttpRequest()
	url = restUrl + nextPageToLoad

	xhr.onloadstart = ->
		moreBtn.textContent = btnLoadingMessage

	xhr.onloadend = ->
		if xhr.status is 200
			if ++nextPageToLoad > maxNbPage
				moreBtn.parentElement.removeChild(moreBtn);
			
			data = JSON.parse(xhr.response)
			for photoData in data
				addNewPhoto(photoData)

			moreBtn.textContent = btnStandardMessage
		else
			alert("Erreur lors de la récupération des photos")
			console.log(JSON.parse(xhr.response))

	xhr.open("GET",url)
	xhr.send()


getPhotoHeight = ->
	totalWidth = window.innerWidth - 20

	if totalWidth > 1220
		imgWidth = 300
	else if totalWidth > 967
		imgWidth = totalWidth / 4
	else if totalWidth > 500
		imgWidth = totalWidth / 2
	else
		imgWidth = totalWidth

	imgHeight = Math.round(imgWidth * 2/3)
	
	return imgHeight + "px"

window.addEventListener("load", =>
	imgHeight = getPhotoHeight()
,false)
window.addEventListener("resize", =>
	imgHeight = getPhotoHeight()
,false)

addNewPhoto = (photoData) ->
	container = document.createElement("div")
	image = document.createElement("img")
	hoverEffect = document.createElement("div")
	information = document.createElement("div")
	loader = new Loader(container)
	loader.show()
	container.className = "new-photo-container"
	image.className = "chatons-dg-photo hide"
	hoverEffect.className = "new-photo-hover"
	information.className = "new-photo-label"

	container.style.height = imgHeight
	textInformation = photoData.comment + " le " + photoData.date

	container.setAttribute("title", textInformation)
	image.setAttribute("alt", textInformation)
	information.textContent = textInformation

	image.src = "/uploads/img/photos/min/" + photoData.id + ".jpg"

	image.onload = ->
		setTimeout(->
			container.style.height = null
			image.className = imgClass
			loader.hide()
		, 500)
	
	container.appendChild(image)
	container.appendChild(hoverEffect)
	hoverEffect.appendChild(information)
	photosContainer.appendChild(container)